export default {
  // APPLICATIONS
  ADD_APPLICATION: {
    url: "/api/v1/applications",
    method: "post",
  },
  GET_APPLICATIONS: {
    url: "/api/v1/customer/applications",
    method: "get",
  },
  GET_APPLICATION_BY_ID: {
    url: "/api/v1/applications/{applicationNumber}",
    method: "get",
  },
  UPDATE_APPLICATION: {
    url: "/api/v1/applications/{applicationNumber}",
    method: "put",
  },
  DELETE_APPLICATION: {
    url: "/api/v1/applications/{applicationNumber}",
    method: "delete",
  },
  REOPEN_APPLICATION: {
    url: "/api/v1/staff/application/reopen/{applicationNumber}",
    method: "put",
  },
  SOFT_DELETE_APPLICATION: {
    url: "/api/v1/admin/application/{applicationId}",
    method: "delete",
  },
  PAYIN_EASEBUZZ_INITIATE: {
    url: "/api/v1/payin-easebuzz/initiate",
    method: "post",
  },
  PAYIN_EASEBUZZ_GET_GENERATE_LINK: {
    url: "/api/v1/staff/payin-easebuzz/generate/link/{loanAccountNumber}",
    method: "get",
  },
  PAYIN_EASEBUZZ_POST_GENERATE_LINK: {
    url: "/api/v1/staff/payin-easebuzz/generate/link",
    method: "post",
  },
  // IDFC
  PAYIN_IDFC_INITIATE: {
    url: "/api/v1/idfc-banking/initiate",
    method: "post",
  },
  PAYIN_IDFC_GET_GENERATE_LINK: {
    url: "/api/v1/staff/idfc-banking/generate/link/{loanAccountNumber}",
    method: "get",
  },
  PAYIN_IDFC_POST_GENERATE_LINK: {
    url: "/api/v1/staff/idfc-banking/generate/link",
    method: "post",
  },
  // YES
  SEND_LOAN_AMOUNT_TO_CUSTOMER_YES_BANK: {
    url: "/api/v1/staff/yes-bank-payout/disburse/{loanAccountNumber}",
    method: "post",
  },
  // IDFC
  SEND_LOAN_AMOUNT_TO_CUSTOMER_IDFC_BANK: {
    url: "/api/v1/staff/idfc-bank-payout/disburse/{loanAccountNumber}",
    method: "post",
  },
  ADMIN_FETCH_TRANSACTION_STATUS: {
    url: "/api/v1/loan-pg/payout/status/{refereceId}",
    method: "get",
  },
  ADMIN_MANUALLY_ADD_CUSTOMER_PAYOUT_DETAILS: {
    url: "/api/v1/staff/yes-bank-payout/manual/{loanAccountNumber}",
    method: "post",
  },
  GET_CUSTOMER_PAYIN_TRANSACTIONS: {
    url: "/api/v1/loan-pg/payin/customer/transaction",
    method: "get",
  },
  ADMIN_GET_CURRENT_WALLET_BALANCE: {
    url: "/api/v1/staff/yes-bank-payout/balance",
    method: "post",
  },
  ADMIN_GET_ALL_PAYOUT_TRANSACTIONS: {
    url: "/api/v1/staff/yes-bank-payout/transactions",
    method: "post",
  },
  // Check Yes Bank FTx payment status (GetStatus)
  CHECK_YES_BANK_FTX_PAYMENT_STATUS: {
    url: "/api/v1/staff/yes-bank-payout/payment-details/{bankRefId}",
    method: "post",
  },
  // LOAN RESTRUCTURE

  GENERAL_GENERATE_OTP_VERIFY: {
    url: "/api/v1/staff/loan-account/verify/otp/{loanAccountNumber}",
    method: "get",
  },

  GENERAL_ADMIN_GENERATE_OTP_VERIFY: {
    url: "/api/v1/staff/loan-account/admin/otp/{loanAccountNumber}",
    method: "get",
  },

  ADD_LOAN_RESTRUCTURE: {
    url: "/api/v1/staff/loan-restructure",
    method: "post",
  },

  GET_PENDING_LOAN_RESTRUCTURE_REQUESTS: {
    url: "/api/v1/staff/loan-restructure/pending",
    method: "get",
  },

  CUSTOMER_ACCEPT_LOAN_RESTRUCTURE_REQUEST: {
    url: "/api/v1/staff/loan-restructure/accept/{loanAccountNumber}",
    method: "put",
  },

  ADMIN_LOAN_RESTRUCTURE_FINAL_APPROVAL: {
    url: "/api/v1/staff/loan-restructure/approved/{loanAccountNumber}",
    method: "put",
  },
};
